export default __webpack_public_path__ + "static/media/batteryError.21f15420.svg";